"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDroplets = void 0;
const createDroplets = ({ httpClient, }) => ({ backups, image, ipv6, monitoring, names, private_networking, region, size, ssh_keys, tags, user_data, volumes, vpc_uuid, }) => {
    const path = '/droplets';
    const body = {
        backups,
        image,
        ipv6,
        monitoring,
        names,
        private_networking,
        region,
        size,
        ssh_keys,
        tags,
        user_data,
        volumes,
        vpc_uuid,
    };
    const url = `${path}`;
    return httpClient.post(url, body);
};
exports.createDroplets = createDroplets;
//# sourceMappingURL=create-droplets.js.map